import { useContext } from 'react';
import { SessionContext } from "../context/index.js";
/**
 * Returns the session data from the SessionContext
 */
export const useSession = () => useContext(SessionContext);
//# sourceMappingURL=use-session.js.map